
/* STICKY ADD TO CART BAR */
const stickySelect = document.getElementById('product-quantity-select-sticky');

stickySelect.addEventListener('change', function() {
	const selectedStickyValue = stickySelect.value;

	const quantity_select = document.getElementById('product-quantity-select');
	const quantity_input = document.getElementById('product-quantity-input');

	quantity_select.value = selectedStickyValue;
	quantity_input.value = selectedStickyValue;
});

const stickyAtc = document.getElementById('sticky-atc');

stickyAtc.addEventListener('click', function() {
	const productMain = stickyAtc.closest('.product--container');
	const submitButton = productMain.querySelector('button[type="submit"]');
	submitButton.click();
});

let productGalleryApi;
let productGalleryTumbsApi;

function product_galleries(){
	/* Main Carousel */
	const emblaNode = document.querySelector('.product_gallery')
	const options = { loop: false, inViewThreshold: 0 }
	const plugins = [EmblaCarouselAutoHeight()]
	productGalleryApi = EmblaCarousel(emblaNode, options, plugins);


	function logSlidesInView(productGalleryApi,selectedIndex) {
		//console.log(productGalleryApi.slidesInView()[0] )

		const emblaThumbs = document.querySelectorAll('.product_gallery-thumbs .product_gallery__slide');

		emblaThumbs.forEach(otherThumb => {
			otherThumb.classList.remove('selected-thumb');
		});

		const emblaNewThumb = document.querySelector('#thumb-slide-'+selectedIndex);
		emblaNewThumb.classList.add('selected-thumb');
	}

	productGalleryApi.on('select', () => {
		const selectedIndex = productGalleryApi.selectedScrollSnap();
		logSlidesInView(productGalleryApi,selectedIndex)
	});


	/* Thumbnail Carousel */
	const emblaTumbsNode = document.querySelector('.product_gallery-thumbs')
	const Tumbsoptions = { loop: false, align: "start", skipSnaps: true }
	productGalleryTumbsApi = EmblaCarousel(emblaTumbsNode, Tumbsoptions);


	/* No longer needed
	document.querySelectorAll('.embla-thumb').forEach(thumb => {
		console.log('found thumb');

		thumb.addEventListener('click', () => {
			productGalleryApi.scrollTo(thumb.dataset.slide)

			console.log('test');
		});
	});*/
}
product_galleries();


/* COLOUR VARIANT SWATCHES
async function ProductColorSwatches() {
	const colour_swatches = document.querySelector('.colour-swatches');
	let colorCount = 0;

	if ( colour_swatches ) {
		try {
			const response = await fetch(`/collections/${product_collection}?view=json_swatches`);
			if (!response.ok) {
				throw new Error(`HTTP error ${response.status}`);
			}
			const data = await response.json();

			for (const item of data.results) {

				if (product_object.key === item.key) {
					colorCount++;
					const colourHandle = item.colour.replace(' ', '-');
					const swatchElement = document.createElement('a');
					swatchElement.href = `/collections/${product_collection}/products/${item.handle}`;
					swatchElement.dataset.colour = item.colour;
					swatchElement.classList.add('colour-swatch');
					swatchElement.classList.add('colour-swatch-'+colorCount);
					if ( item.colour === product_object.colour ) {
						swatchElement.classList.add('selected');
					}

					if (item.title.includes('NRL')) {
						swatchElement.classList.add('no-padding');
					}

					swatchElement.title = item.colour;
					const imgElement = document.createElement('img');
					imgElement.src = item.image;
					imgElement.width = 50;
					imgElement.height = 50;
					imgElement.alt = `${item.title} swatch`;
					swatchElement.appendChild(imgElement);
					colour_swatches.prepend(swatchElement);
				}
			}
			colour_swatches.style.opacity = "1";

			if (colorCount === 0) {
				document.querySelector('.colour-swatches').style.minHeight = '0px';
			}

			colour_swatches.addEventListener('click', (event) => {
				if (event.target.classList.contains('colour-swatch')) {


					event.preventDefault();

					document.querySelectorAll('.colour-swatch').forEach(swatch => {
						swatch.classList.remove('selected');
					});
					event.target.classList.add('selected');

					const href = event.target.getAttribute('href');

					//Auto redirect
					//window.location.href = href;

					//window.history.pushState({}, "", href);

					fetch(href+'?sections='+section_id)
					.then(response => response.text())
					.then(html => {

						parsedHTML = JSON.parse(html)
						//console.log(parsedHTML)

						const parsedSection = parsedHTML[section_id]

						//console.log(parsedSection)

						var parser = new DOMParser();
						var sectionHTML = parser.parseFromString(parsedSection, 'text/html');

						productGalleryApi.destroy();
						productGalleryTumbsApi.destroy();

						document.querySelector('.product-title').innerHTML = sectionHTML.querySelector('.product-title').innerHTML;
						document.querySelector('#product-price-selector').innerHTML = sectionHTML.querySelector('#product-price-selector').innerHTML;
						document.querySelector('.product-galleries').innerHTML = sectionHTML.querySelector('.product-galleries').innerHTML;

						document.querySelector("#selected-variant-id").innerHTML = sectionHTML.querySelector('#selected-variant-id').innerHTML;
						console.log( document.querySelector('.product-form--atc').innerHTML )
						document.querySelector('.product-form--atc').innerHTML = sectionHTML.querySelector('.product-form--atc').innerHTML;
						//document.querySelector('.product-form--regular').innerHTML = sectionHTML.querySelector('.product-form--regular').innerHTML;
						document.querySelector('.sticky-info').innerHTML = sectionHTML.querySelector('.sticky-info').innerHTML;

						//check for upsells
						const product_upsells = document.querySelector('#product-upsells')
						const product_upsells_new = sectionHTML.querySelector('#product-upsells')
						if ( product_upsells && product_upsells_new ) {
							product_upsells.innerHTML = product_upsells_new.innerHTML;
							init_product_upsell();
						}

						//check for variants - used in kids multisize products
						const product_options = document.querySelector('.product-options-style-radio')
						const product_options_new = sectionHTML.querySelector('.product-options-style-radio')
						if ( product_options && product_options_new ) {
							product_options.innerHTML = product_options_new.innerHTML;
						}

						//Duplicate scripts
						const product_scripts = document.querySelector('#product-scripts');
						const product_scripts_new = sectionHTML.querySelector('#product-scripts');

						if (product_scripts && product_scripts_new) {
							product_scripts.innerHTML = product_scripts_new.innerHTML;

							// Re-run inline scripts
							const scripts = product_scripts.querySelectorAll('script');
							scripts.forEach((oldScript) => {
								const newScript = document.createElement('script');
								if (oldScript.src) {
									newScript.src = oldScript.src;
								} else {
									newScript.textContent = oldScript.textContent;
								}
								// Copy attributes if needed (like type, async, etc.)
								[...oldScript.attributes].forEach(attr =>
									newScript.setAttribute(attr.name, attr.value)
								);
								oldScript.replaceWith(newScript);
							});

							productVariantChange();
						}

						product_galleries();
						ajax_add_to_cart();
						//multibuy();


						//setTimeout(() => {
							//window.history.replaceState({}, "", href);
						//}, 5000);
					})
					.catch(e => {
						console.error(e);
					});


				}
			});


		} catch (error) {
			console.error('Error fetching or processing data:', error);
			// Handle the error gracefully, e.g., display an error message to the user
		}
	}
}
*/

// Pull for 'Individual' collection
//ProductColorSwatches();

function productVariantChange(){
	console.log('variant change');
	const optionRadios = document.querySelectorAll('.product-options-style-radio .option-value-input');
	const selectedVariantIdInput = document.querySelector('#selected-variant-id input');
	const productPrice = document.querySelector('.product--price ');
	const productComparePrice = document.querySelector('.product--compare-at-price');

	function updateSelectedVariant() {

		const selectedOptions = {};
		optionRadios.forEach(radio => {
			if (radio.checked) {
				selectedOptions[`option${radio.dataset.optionIndex}`] = radio.value;
			}
		});

		//Check each option to see if the matching variant exists and is available
		optionRadios.forEach(radio => {
			const optionName = radio.getAttribute('name').replace('-', '');
			let OptionOptions = { ...selectedOptions };

			if (optionName in OptionOptions) {
				OptionOptions[optionName] = radio.value;
			}

			const matchingVariant = product_variants.find(variant => {
				return Object.keys(OptionOptions).every(optionName => {
					return variant[optionName] === OptionOptions[optionName];
				});
			});

			if (matchingVariant && matchingVariant.available) {
				radio.nextElementSibling.style.display = "flex"
			} else {
					if (radio.nextElementSibling && radio.nextElementSibling.classList.contains('option-type-frame')) {
				radio.nextElementSibling.style.display = "none"
				}
			}
		});

		const selectedVariant = product_variants.find(variant => {
			return Object.keys(selectedOptions).every(optionName => {
				return variant[optionName] === selectedOptions[optionName];
			});
		});

		if (selectedVariant) {
			console.log('selectedVariant')
			selectedVariantIdInput.value = selectedVariant.id;
			updateProductUrl(selectedVariant.id);

			fetch(window.location.href+'&sections='+section_id)
			.then(response => response.text())
			.then(html => {

				parsedHTML = JSON.parse(html)

				const parsedSection = parsedHTML[section_id]
				const parser = new DOMParser();
				const sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				const sections_to_update = [
					".product-form--atc",
					"#product-price-selector"
				]

				//console.log( sectionHTML )
				sections_to_update.forEach(update_id => {
					//console.log( update_id )
					if (document.querySelector(update_id)) {
						document.querySelector(update_id).innerHTML = sectionHTML.querySelector(update_id).innerHTML;
					}
				});
			})
			.catch(e => {
				console.error(e);
			});

		} else {
			const productCta = document.querySelector('.product-form--atc-qty');
			const productCtaButton = productCta.querySelector('#AddToCart');

			if (productCtaButton) {
				productCtaButton.classList.add('disabled');
			}
		}
	}

	function updateProductUrl(variantId) {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', currentUrl);
	}

	optionRadios.forEach(radio => {
		radio.addEventListener('change', updateSelectedVariant);
	});

	//Check if we have a product with multiple options (gift cards)
	const product_options_radio = document.querySelector('.product-options-style-radio');
	if (product_options_radio) {
		updateSelectedVariant();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	productVariantChange();
});

function ajax_add_to_cart(){
	// Add To Cart
	// Not for bundles or 'all colours' products
	const productForm = document.querySelector('form.ajax-submit');
	productForm.addEventListener('submit', (event) => {
		event.preventDefault();

		const selectedId = productForm.querySelector("input[name='id']").value;
		let form_properties = {}

		const inputProperties = document.querySelectorAll('[name*="properties"]');
		inputProperties.forEach(input => {
			let nameValue = input.name;
			nameValue = nameValue.replace('properties[', '').replace(']', '');

			if ((input.type === "text" || input.type === "email" || input.tagName.toLowerCase() === "textarea") && input.value.trim() !== "" ) {
				form_properties[nameValue] = input.value
			}
			if (input.type === "radio" && input.checked){
				form_properties[nameValue] = input.value;
			}
			if (input.type === "checkbox" && input.checked){
					if (input.id === "recipient-checkbox") {
					form_properties[nameValue] = true
				} else {
					form_properties[nameValue] = input.value
				}
			}
			if ( input.type === "date"){
				form_properties[nameValue] = input.value
			}
		});

		//Check if any upsell selected
		let selected_variants = [
			{
				quantity: 1,
				id: selectedId
			}
		];

		const upsellInputs = document.querySelectorAll('.product-upsell input');

		upsellInputs.forEach(input => {
			if (input.checked) {
				const selected_variant = {
					quantity: 1,
					id: input.value
				}
				selected_variants.push(selected_variant);
			}
		});

		console.log('ajax_add_to_cart')
		console.log(selectedId);
		console.log(form_properties);

		if (selected_variants.length > 	1) {
			//If adding upsell
			addProductsToCart(selected_variants)
		} else {
			//Add single product
			if (selectedId) {
				addProductToCart(selectedId,form_properties)
			}
		}
	});
}
ajax_add_to_cart();

function init_product_upsell(){
	const upsellInputs = document.querySelectorAll('.product-upsell input');
	let productPrice = document.querySelector('.price--main').dataset.price;
	let productComparePrice = document.querySelector('.price--compare-at').dataset.price;

	function updateUpsellPrices(productPrice,productComparePrice){
		const updatedProductPrice = productPrice / 100.00
		const updatedComparePrice = productComparePrice / 100.00
		document.querySelector('.price--main').innerHTML = `$${updatedProductPrice.toFixed(2)} ${cart_currency}`;
		document.querySelector('.price--compare-at').innerHTML = `$${updatedComparePrice.toFixed(2)} ${cart_currency}`;
	}

	upsellInputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.dataset.price) {
				if (input.checked) {
					productPrice = Number(productPrice) + Number(input.dataset.price)
					productComparePrice = Number(productComparePrice) + Number(input.dataset.price)
				} else {
					productPrice = document.querySelector('.price--main').dataset.price;
					productComparePrice = document.querySelector('.price--compare-at').dataset.price;
				}
				updateUpsellPrices(productPrice,productComparePrice);
			}
		});

		if (input.classList.contains('auto-add-true')) {
			input.checked = true;
		}

		input.dispatchEvent(new Event('change'));
	});
}
init_product_upsell();

/* Back in Stock */
document.addEventListener('DOMContentLoaded', () => {
const emailInput = document.querySelector('#stock-notification-form-email');
	const bisEmailInput = document.querySelector('.bis-email-input');
	const stockButton = document.querySelector('#stock-notification-form button');
	const bisSubmitBtn = document.querySelector('.bis-submit-btn');

	if (emailInput && bisEmailInput) {
		// When user types or changes the email input, mirror it
		emailInput.addEventListener('input', () => {
			bisEmailInput.value = emailInput.value;
		});
	}

	if (stockButton && bisSubmitBtn) {
		console.log('has both btns');
		// When the stock form button is clicked, trigger the BIS submit button
		stockButton.addEventListener('click', (e) => {
			console.log('bis clicked');

			e.preventDefault(); // prevent duplicate submission if both submit forms
			bisSubmitBtn.classList.add('clicked');
			bisSubmitBtn.click(); // or use bisSubmitBtn.submit() if it’s a <form>
		});
	}
});


/* Function never used 17/7/24
function getSelectedValue() {
	const
	selectedRadio = document.querySelector('input[name="multi-quantity"]:checked'),
	afterpayParagraph = document.getElementById('afterpay-wrap');
	multiBuyATC = document.getElementById('add-multi-pack'),
	productPrice = document.querySelector('.price--main');

	AddToCartBtn = document.getElementById('AddToCart');

	productPrice.innerHTML = event.target.dataset.price;

	if (selectedRadio) {
		ga_event('multi_buy','Quantity Change',selectedRadio.value);

		if ( selectedRadio.value == '1' ) {
			const selectedValue = selectedRadio.value;
			AddToCartBtn.style.display = 'block'
			multiBuyATC.style.display = 'none'
			afterpayParagraph.style.display = 'block'
		} else {
			AddToCartBtn.style.display = 'none'
			multiBuyATC.style.display = 'block'
			afterpayParagraph.style.display = 'none'
		}
	} else {
		//console.log("No radio button with name 'multi-quantity' is selected.");
	}
}

function multibuy(){

	$('#add-multi-pack').click(function(e){

		const button = $(this);

		let
			selected_variants = [],
			bundle_type = "multi_buy";

		const
			quantity = document.querySelector('input[name="multi-quantity"]:checked'),
			variantID = document.querySelector('input[name="id"]');

		if ( product_object.type == 'Towel'){
			bundle_type = "multi_buy_towel";
		}

		selected_variant = {
			quantity: quantity.value,
			id: variantID.value,
			properties: {
				'_bundle': bundle_type
			}
		}
		selected_variants.push(selected_variant)

		button.prop("disabled", true).html('Adding To Cart');

		ga_event('multi_buy','Add To Cart',quantity.value);
		addProductsToCart(selected_variants,button)
	});

	const multiBuyInputs = document.querySelectorAll('input[name="multi-quantity"]');
	multiBuyInputs.forEach(radio => radio.addEventListener('change', getSelectedValue));
}
multibuy();*/